import { useRef, useState, useEffect, useContext } from "react";
import DatePicker from "react-multi-date-picker";
import DataTable from "../../../Assets/Images/calendar-1 1.svg";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import _axios from "../../../httpService";
import "./FactorJoz.scss";
import CodeCustomer from "./CodeCustomer";
import { prefixUrl } from "../../../utils/utilsData";
import numeric from "../../../utils/NumericFunction";
import commaSeparator, {
  formatToPersianAddComma,
} from "../../../utils/CommaSeparator";
import { toast } from "react-toastify";
import { parseToEnRemoveComma } from "../../../utils/CommaSeparator";
import { useNavigate } from "react-router-dom";

const FactorJoz = (props) => {
  let {
    backendData,
    totalInvoice,
    totalColumnSum,
    recordData,
    initialData,
    mode,
  } = props;
  const [customerCode, setcustomerCode] = useState({
    customerName: "",
    customerId: "",
  });
  let [factorDate, setFactorDate] = useState("");
  const [Payment, setPayment] = useState("");
  const [Discount, setDiscount] = useState("");
  const [Description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const dateCal = useRef(null);
  const [SumTotalInvoice, setSumTotalInvoice] = useState(0);
  const [PaymentAmount, setPaymentAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [invoiceBalance, setInvoiceBalance] = useState(0);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const todayDate = new Date().toLocaleDateString("fa-IR", options);
  const navigateTo = useNavigate();

  useEffect(() => {
    if (factorDate === "") {
      setFactorDate(todayDate);
      // setSendData({date: todayDate})
    }
    const sumNumValue = Number(totalColumnSum);
    let payment = Payment;
    if (isNaN(payment)) {
      payment = 0;
    }
    const paymentValue = Number(payment);
    setPaymentAmount(paymentValue);
    let discount = Discount;
    if (isNaN(discount)) {
      discount = 0;
    }
    const discountValue = Number(discount);
    const calculatedTotalAmount = sumNumValue - paymentValue - discountValue;
    setTotalAmount(calculatedTotalAmount);
    const sumTotal = sumNumValue - discountValue;
    setSumTotalInvoice(sumTotal);

    // Calculate invoice balance
    const invoiceBalanceValue = sumTotal - paymentValue;
    setInvoiceBalance(invoiceBalanceValue);
  }, [totalInvoice, totalColumnSum, Payment, Discount, factorDate]);

  useEffect(() => {
    if (Object.entries(props.backendData).length !== 0) {
      setDiscount(props.backendData.discount);
      setPayment(props.backendData.paidPrice);
      setDescription(props.backendData.description);
      setFactorDate(props.backendData.date);
      setcustomerCode({
        ...customerCode,
        customerId: props.backendData.customerId,
      });
    }
  }, [props.backendData]);

  const handlePaymentChange = (e) => {
    const value = e.target.value;
    // const formattedValue = Number(value);
    const enteredValue = parseToEnRemoveComma(e.target.value);
    const formattedValue = enteredValue.replace(/[^0-9]/g, "");
    // const payment = formatToPersianAddComma(formattedValue);
    setPayment(formattedValue);
  };

  const handleDiscountChange = (e) => {
    const value = e.target.value;
    // const formattedValue = Number(value);
    const enteredValue = parseToEnRemoveComma(e.target.value);
    const formattedValue = enteredValue.replace(/[^0-9]/g, "");
    // const discount = formatToPersianAddComma(formattedValue);
    setDiscount(formattedValue);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleDateChange = (selectedDate) => {
    setFactorDate(selectedDate);
  };

  function isDateValid(date) {
    // Split the date string by '/'
    const dateParts = date.split('/');
  
    // Check if there are exactly 3 parts (year, month, and day)
    if (dateParts.length !== 3) {
      return false;
    }
  
    // Check if each part has the correct length
    if (dateParts[0].length === 4 && dateParts[1].length === 2 && dateParts[2].length === 2) {
      return true;
    }
  
    return false;
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (recordData.length === 0) {
      // Display an error message if recordData is empty
      toast.error("لطفا جدول را پر کنید.");
      return;
    }

    if (customerCode.customerId === "") {
      toast.error("لطفا کدمشتری را به درستی پر کنید.");
      return;
    }

    if (factorDate === "") {
      toast.error("لطفا تاریخ را به درستی پر کنید.");
      return;
    }

    if (!isDateValid(factorDate)) {
      toast.error("لطفا تاریخ را به درستی وارد کنید.");
      return;
    }

    debugger;

    // Ensure that empty values are sent as empty strings to the backend
    const formattedPayment = Payment === "" ? 0 : Number(Payment);
    const formattedDiscount = Discount === "" ? 0 : Number(Discount);
    const formattedDescription = Description === "" ? "" : Description;

    const isEditModeWithBackendData = backendData.id;

    let selectedCustomerId = isEditModeWithBackendData
      ? backendData.customerId
      : customerCode.customerId;

    // If the user has selected a new customer, use the selected customerId
    if (
      customerCode.customerId !== "" &&
      customerCode.customerId !== backendData.customerId
    ) {
      selectedCustomerId = customerCode.customerId;
    }

    const calculatedTotalAmount =
      totalColumnSum - formattedDiscount;

    if (formattedPayment > calculatedTotalAmount) {
      toast.error("مبلغ پرداختی نمی‌تواند بیشتر از مبلغ کل فاکتور باشد.");
      return;
    }

    const data = {
      request: "factorConfirm",
      factorData: {
        customerId: selectedCustomerId,
        date: numeric.p2e(factorDate),
        paidPrice: formattedPayment,
        discount: formattedDiscount,
        description: formattedDescription,
        totalAmount: totalAmount,
        factorDetail: recordData,
        mode,
      },
    };

    if (backendData.id) {
      data.factorData.id = backendData.id;
    }

    console.log("Data to be sent to the backend:", data);

    _axios
      .post(prefixUrl() + "/shutterFactor/", data)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setcustomerCode("");
          setFactorDate("");
          setPayment("");
          setDiscount("");
          setDescription("");
          setErrorMessage("");
          navigateTo(-1);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        // در صورت بروز خطا
        console.error(error);
      });
  };

  return (
    <div className="FaktorJoz">
      <div className="FactorJozUp">
        <form>
          <CodeCustomer
            initialData={initialData}
            customerCode={customerCode}
            setcustomerCode={setcustomerCode}
            backendData={backendData}
          />

          <div className="Date">
            <label>تاریخ ثبت</label>
            <DatePicker
              ref={dateCal}
              calendar={persian}
              className="Date"
              placeholder="تاریخ ثبت را انتخاب کنید"
              locale={persian_fa}
              value={factorDate}
              calendarPosition="bottom-right"
              hideOnScroll
              onChange={(factorDate) => {
                if (factorDate) {
                  handleDateChange(factorDate.toLocaleString());
                } else {
                  handleDateChange("");
                }
              }}
            />
            <div className="imageDate">
              <img src={DataTable} alt="" />
            </div>
          </div>

          <div className="Payment">
            <label>پرداخت</label>
            <input
              type="text"
              placeholder="مبلغ مورد نظر را وارد کنید"
              value={formatToPersianAddComma(Payment)}
              onChange={handlePaymentChange}
            />
          </div>

          <div className="Discount">
            <label>تخفیف</label>
            <input
              type="text"
              placeholder="مقدار تخفیف را وارد کنید"
              value={formatToPersianAddComma(Discount)} 
              onChange={handleDiscountChange}
            />
          </div>

          <div className="Description">
            <label>توضیحات</label>
            <input
              type="textarea"
              placeholder="توضیحات خود را وارد کنید"
              value={Description}
              onChange={handleDescriptionChange}
            />
          </div>

          <div className="SumTotalInvoice">
            <span>جمع کل فاکتور</span>
            <span className="SumTotalInvoiceNum">
              {formatToPersianAddComma(SumTotalInvoice)} ریال
            </span>
          </div>

          <div className="PaymentAmount">
            <span>مبلغ پرداخت</span>
            <span className="PaymentAmountNum">
              {formatToPersianAddComma(PaymentAmount)} ریال
            </span>
          </div>

          <div className="invoiceBalance">
            <span>مانده فاکتور</span>
            <span className="invoiceBalanceNum">
              {formatToPersianAddComma(totalAmount)} ریال
            </span>
          </div>

          <div className="Responsive">
            <div className="SumTotalInvoiceResponsive">
              <span>جمع کل فاکتور</span>
              <span className="SumTotalInvoiceNum">
                {commaSeparator(SumTotalInvoice)} ریال
              </span>
            </div>

            <div className="PaymentAmountResponsive">
              <span>مبلغ پرداخت</span>
              <span className="PaymentAmountNum">
                {commaSeparator(Number(PaymentAmount))} ریال
              </span>
            </div>

            <div className="invoiceBalanceResponsive">
              <span>مانده فاکتور</span>
              <span className="invoiceBalanceNum">
                {commaSeparator(Number(invoiceBalance))} ریال
              </span>
            </div>
          </div>

          {/* <button className='btnSubmitForm' type='submit'>ثبت</button> */}
          <div className="btnsubmitandPrint">
            <div className="btnsubmit">
              <button onClick={(e) => e.preventDefault()} type="submit">
                ثبت و پرینت
              </button>
            </div>
            <div className="submit-btn">
              <button id="submit-btn" type="submit" onClick={handleSubmit}>
                ثبت
              </button>
            </div>
          </div>

          {errorMessage && <p>{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
};

export default FactorJoz;
